@if (viewActive === 'list') {
<p-table
  [first]="first"
  [value]="orders"
  [rows]="rows"
  [paginator]="true"
  [loading]="loadingData"
  (onLazyLoad)="loadPrimeTableData($event)"
  [lazy]="true"
  [totalRecords]="totalRows"
  [rowsPerPageOptions]="[10, 25, 50]"
  responsiveLayout="stack"
  dataKey="id"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  [tableStyle]="{ 'min-width': '15rem' }"
  styleClass="p-datatable-striped p-datatable-sm"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">
      <h5 class="m-0">Solicitudes de compra pendientes</h5>
      <p-button icon="pi pi-refresh" (click)="reloadPage()" />
    </div>
  </ng-template>
  @if (loadingPage) {
  <app-loading-element [text]="'Generando orden de venta'" />
  }
  <ng-template pTemplate="header">
    <tr>
      <th>Fecha</th>
      <th>Estado</th>
      <th>Monto OV</th>
      <th>Folio OC</th>
      <th>Monto OC</th>
      <th>Solicita</th>
      <th>Acciones</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-order of orders>
    <tr
      class="justify-content-center gap-3"
      [ngClass]="{
        'border-gray-400 border-bottom-3': isMobile()
      }"
    >
      <td
        [ngClass]="{
          'hidden p-0': !order.updatedAt,
          'p-1 border-bottom-1 border-solid border-gray-200': order.updatedAt
        }"
      >
        <div class="p-column-title">Fecha:</div>
        <div class="md:col-12 col-6 p-0">
          {{ order.updatedAt | date : 'dd-MM-yyyy HH:mm' }}
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order.status,
          'p-1 border-bottom-1 border-solid border-gray-200': order.status
        }"
      >
        <div class="p-column-title">Estado:</div>
        <div class="md:col-12 col-6 p-0">
          <span
            class="badge-status"
            [ngClass]="{
              'bg-danger': order.status == 'rejected',
              'bg-warning': order.status == 'pending',
              'bg-info': order.status == 'generated',
              'bg-success': order.status == 'finalized',
              'bg-secondary': order.status == 'Desconocido'
            }"
          >
            {{ order.status | translateStatus }}
          </span>
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order?.total,
          'p-1 border-bottom-1 border-solid border-gray-200': order?.total
        }"
      >
        <div class="p-column-title">Monto OV:</div>
        <div class="md:col-12 col-6 p-0">
          {{ order?.total | currency }}
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order.purchaseOrderNumber,
          'p-1 border-bottom-1 border-solid border-gray-200':
            order.purchaseOrderNumber
        }"
      >
        <div class="p-column-title">Folio OC:</div>
        <div class="md:col-12 col-6 p-0">
          {{ order.purchaseOrderNumber }}
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order.purchaseOrderAmount,
          'p-1 border-bottom-1 border-solid border-gray-200':
            order.purchaseOrderAmount
        }"
      >
        <div class="p-column-title">Monto OC:</div>
        <div class="md:col-12 col-6 p-0">
          {{ order.purchaseOrderAmount | currency }}
        </div>
      </td>
      <td
        [ngClass]="{
          'hidden p-0': !order?.user,
          'p-1 border-bottom-1 border-solid border-gray-200': order?.user
        }"
      >
        <div class="p-column-title">Usuario:</div>
        <div class="md:col-12 col-6 p-0">
          {{ order?.user }}
        </div>
      </td>
      <td
        class="button-container p-d-flex p-flex-column p-md-flex-row p-jc-between p-md-jc-end p-ai-center"
      >
        <div class="right-buttons p-d-flex p-jc-end">
          @if ( usuario.userRole === userRoles.SUPERVISOR &&
          order?.purchaseOrder?.number != null && order?.status === 'pending' )
          {
          <button
            pButton
            pRipple
            icon="pi pi-check"
            class="p-button-rounded p-button-success mr-2"
            (click)="approveOrder(order)"
          ></button>
          } @if ( usuario.userRole === userRoles.SUPERVISOR &&
          order?.purchaseOrder?.number != null && order?.status === 'pending' )
          {
          <button
            pButton
            pRipple
            icon="pi pi-times"
            class="p-button-rounded p-button-danger"
            (click)="refuseOrder(order)"
          ></button>
          }
          <button
            pButton
            pRipple
            icon="pi pi-eye"
            class="p-button-rounded p-button-info mr-2 ml-2"
            (click)="viewOrderDetail(order)"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
} @if (viewActive == 'detail') {
<button class="btn btn-border-primary mb-3" (click)="backToList()">
  <i class="fas fa-chevron-left"></i>
  Atrás
</button>
@if ( order?.purchaseOrder?.number != null && usuario.userRole == 'supervisor'
&& order?.status == 'pending' ) {
<button
  class="btn btn-border-primary mb-3 float-end"
  (click)="approveOrder(order)"
>
  <i class="far fa-thumbs-up"></i>
  Aprobar
</button>
} @if ( order?.purchaseOrder?.number != null && usuario.userRole ==
'supervisor' && order?.status == 'pending' ) {
<button
  class="btn btn-border-primary mb-3 float-end me-2"
  (click)="refuseOrder(order)"
>
  <i class="far fa-thumbs-down"></i>
  Rechazar
</button>
} @if ( order?.purchaseOrder?.number == null && usuario.userRole ==
'supervisor' && order?.status == 'pending' ) {
<button class="btn btn-border-primary mb-3 float-end" (click)="backToList()">
  <i class="fas fa-marker"></i>
  Completar
</button>
}
<app-order-details
  [title]="'Solicitud de compra'"
  [id]="orderId"
></app-order-details>
}

<ng-template #modalApprove>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Aprobar solicitud de compra</h4>
    <button
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="modalApproveRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body-min">
    ¿Esta seguro que desea aprobar la solicitud de compra?
  </div>

  <div class="modal-footer">
    <button class="btn btn-border-primary" (click)="modalApproveRef.hide()">
      <i class="fas fa-ban"></i>
      Cancelar
    </button>

    <button class="btn btn-secondary" (click)="confirmApproveOrder()">
      <i class="fas fa-check"></i>
      Aceptar
    </button>
  </div>
</ng-template>

<ng-template #modalRefuse>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Rechazar solicitud de compra</h4>
    <button
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="modalRefuseRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body-min">
    ¿Esta seguro que desea rechazar la solicitud de compra?

    <div class="mb-3 mt-3">
      <label>Observación</label>
      <textarea
        rows="3"
        class="form-control"
        [(ngModel)]="obsRefuse"
      ></textarea>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-border-primary" (click)="modalRefuseRef.hide()">
      <i class="fas fa-ban"></i>
      Cancelar
    </button>

    <button class="btn btn-danger" (click)="confirmRefuseOrder()">
      <i class="fas fa-check"></i>
      Aceptar
    </button>
  </div>
</ng-template>
